export const drugExposureRows = [
  "Cannabis",
  "Powder Cocaine",
  "Crack Cocaine",
  "MDMA",
  "Amphetamine",
  "Methamphetamine",
  "Ketamine",
  "Spice (Synthetic Cannabinoids)",
  "Heroin",
  "Codeine",
  "Dihydrocodeine",
  "Morphine",
  "Oxycodone (including oxymorphone)",
  "Diazepam (including nordiazepam)",
  "Other Benzodiazepines (please specify below)",
  "Amitriptyline",
  "Pregabalin",
  "Gabapentin",
  "Buprenorphine",
  "Methadone",
  "Tramadol",
  "Other illicit substances not listed",
];
